import z from 'zod';
import {FirestoreTimestampAdmin, firestoreTimestampAdminSchema} from './firestoreTimestampAdminSchema';
import {FirestoreTimestampClient, firestoreTimestampClientSchema} from './firestoreTimestampClientSchema';
import {FirestoreTimestampCreator, firestoreTimestampCreatorSchema} from './firestoreTimestampCreatorSchema';

export const firestoreTimestampSchema = z.union([
  firestoreTimestampAdminSchema,
  firestoreTimestampClientSchema,
  firestoreTimestampCreatorSchema,
]);

export type FirestoreTimestamp = FirestoreTimestampAdmin | FirestoreTimestampClient | FirestoreTimestampCreator;
